
import { defineComponent, ref, reactive, toRefs } from "vue";

export default defineComponent({
  props: ["title", "img", "isSlot"],
  setup(props) {
    return {
      ...toRefs(props),
    };
  },
});
